(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casa-welcome-signup"] && !Shopify.designMode) return;
  try {
    (()=>{const d=document.getElementById('CasaWelcome');if(!d)return;
const key='casa-welcome-15-session-v1';
const remember=()=>{try{sessionStorage.setItem(key,'dismissed')}catch{}};
const close=()=>{remember();d.close()};
d.querySelector('.welcome-close').addEventListener('click',close);
d.querySelector('.welcome-later').addEventListener('click',close);
d.addEventListener('cancel',remember);
let dismissed=false;try{dismissed=!!sessionStorage.getItem(key)}catch{}
if(d.querySelector('[data-welcome-success]')||d.querySelector('.errors')){d.showModal();return}
if(!dismissed)setTimeout(()=>{if(!d.open)d.showModal()},1200);
})();
  } catch(e) { console.error(e); }
})();

})();
